import { Dialog } from '@ark-ui/react';
import { ReactNode, useId } from 'react';
import { Portal } from '../Portal';
import styles from './Modal.module.scss';

export interface ModalProps {
  open: boolean;
  onOpenChange?: (details: { open: boolean }) => void;
  children: ReactNode;
  title?: string;
  description?: string;
  'aria-label'?: string;
  closeOnInteractOutside?: boolean;
  closeOnEscape?: boolean;
  'data-testid': string;
}

export const Modal = ({
  open,
  onOpenChange,
  children,
  title,
  description,
  'aria-label': ariaLabel,
  closeOnInteractOutside = true,
  closeOnEscape = true,
  'data-testid': dataTestid,
}: ModalProps) => {
  const titleId = useId();

  if (!open) return null;

  return (
    <Dialog.Root
      open
      onOpenChange={onOpenChange}
      closeOnInteractOutside={closeOnInteractOutside}
      closeOnEscape={closeOnEscape}
    >
      <Portal>
        <Dialog.Backdrop
          className={styles['backdrop']}
          data-testid={`${dataTestid}-backdrop`}
        />
        <Dialog.Positioner className={styles['positioner']}>
          <Dialog.Content
            className={styles['content']}
            data-testid={dataTestid}
            aria-label={!title ? ariaLabel : undefined}
            aria-labelledby={title ? titleId : undefined}
          >
            {title && (
              <Dialog.Title id={titleId} className={styles['title']}>
                {title}
              </Dialog.Title>
            )}
            {description && (
              <Dialog.Description className={styles['description']}>
                {description}
              </Dialog.Description>
            )}
            {children}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
